import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import ForgotPasswordOTP from "./pages/ForgotPasswordOTP";

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));

// Auth check function
const isAuthenticated = () => {
  return !!localStorage.getItem("adminToken");
};

// Protected Route Component
const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

// Public Route Component (for non-authenticated users)
const PublicRoute = ({ component: Component, restricted = false, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() && restricted ? (
        <Redirect to="/app" />
      ) : (
        <Component {...props} />
      )
    }
  />
);

function App() {
  // console.log("App component loaded");
  return (
    <>
      <Router>
        <AccessibleNavigationAnnouncer />
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            {/* Public routes */}
            <PublicRoute path="/login" component={Login} restricted />
            <PublicRoute path="/forgot-password" component={ForgotPasswordOTP} restricted />

            {/* Protected routes — creating a new admin requires an existing admin to be logged in */}
            <ProtectedRoute path="/create-account" component={CreateAccount} />
            <ProtectedRoute path="/app" component={Layout} />
            
            {/* Add more protected routes as needed */}
            {/* <ProtectedRoute path="/add-category" component={AddCategory} /> */}

            {/* Default redirect */}
            <Redirect exact from="/" to={isAuthenticated() ? "/app" : "/login"} />
          </Switch>
        </Suspense>
      </Router>
    </>
  );
}

export default App;